"use strict";
var $ = require("../internals/export");
$({ target: "Number", stat: true, nonConfigurable: true, nonWritable: true }, {
  MIN_SAFE_INTEGER: -9007199254740991
});
